export const ACCURACY = 5;
const LICENSE_AGREEMENT_VERSION = '1.0';
export const USER_AGREEMENT = {
  KEY: `User_License_Agreement_Accepted_v${LICENSE_AGREEMENT_VERSION}`,
  VALUE: 'true',
};
